import {gql} from "@apollo/client";

export const REWARDMAPPING_ENTITY = gql`
    fragment RewardMappingEntity on RewardMapping {
        id
        customProps
        template
        triggeredBy
    }
`;